import { APIPutRequest } from '@ancon/wildcat-types'

import Request from '../../client/Request'
import endpoints from '../endpoints'

type OrderRefundReceiptsAPI = {
  put: {
    download: APIPutRequest<
      Blob,
      {},
      { outletId: string; orderId: string; paymentId: string; refundId: string }
    >
    send: APIPutRequest<
      void,
      { toEmail: string },
      { outletId: string; orderId: string; paymentId: string; refundId: string }
    >
  }
}

const orderRefundReceipts: OrderRefundReceiptsAPI = {
  put: {
    send: new Request(
      endpoints.core.outlets.byId.orders.byId.payments.byId.refunds.byId.sendReceipt.list,
      {
        version: 1.4,
      },
    ).put,
    download: new Request(
      endpoints.core.outlets.byId.orders.byId.payments.byId.refunds.byId.downloadReceipt.list,
      {
        version: 1.4,
      },
    ).put,
  },
}

export default orderRefundReceipts
